module.exports = __webpack_public_path__ + "img/Monito.1544e24e.svg";